<template>
  <div>
    <h1 class="page-header">{{ $t('payItemAllowance.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">
              {{ $t('addNew') }}
            </ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.allowance_item }}</td>
            <td>
              <i class="fas fa-check ts-text-green-500" v-show="record.is_taxable"></i>
              <i class="fas fa-times ts-text-red-500" v-show="!record.is_taxable"></i>
            </td>
            <td>{{ record.fringe_benefit_percent }}</td>
            <td>{{ record.tax_withholding_percent }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <!-- <a
                href="#"
                v-tooltip="'Delete'"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a> -->
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'pay-item-allowance',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/payItemAllowance', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.payItemAllowance.search
      },
      set(newValue) {
        this.$store.commit('hr/payItemAllowance/SET_SEARCH', newValue)
        this.$store.commit('hr/payItemAllowance/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('payItemAllowance.allowanceItem'),
          sortKey: 'allowance_item'
        },
        {
          name: this.$t('payItemAllowance.isTaxable'),
          sortKey: 'is_taxable'
        },
        {
          name: this.$t('payItemAllowance.fringeBenefitPercent'),
          sortKey: 'fringe_benefit_percent'
        },
        {
          name: this.$t('payItemAllowance.taxWithholdingPercent'),
          sortKey: 'tax_withholding_percent'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/payItemAllowance/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/payItemAllowance/destroy', record.allowance_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/payItemAllowance/RESET_STATE')
    next()
  }
}
</script>
